module.exports = __webpack_public_path__ + "r-v3/img/translation_DE.ebbdea29.png";